// extracted by mini-css-extract-plugin
export default {"globalLoader":"GlobalLoader_globalLoader__WfmoK"};